import { render } from "./Djs.vue?vue&type=template&id=5d5fcd0b"
import script from "./Djs.vue?vue&type=script&lang=js"
export * from "./Djs.vue?vue&type=script&lang=js"

import "./Djs.vue?vue&type=style&index=0&id=5d5fcd0b&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__